export default __webpack_public_path__ + "static/media/NoirPro-Bold.fa1d4e28.woff2";